var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgP4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 190,
    height: 165.5,
    viewBox: "0 0 190 165.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(-1090.5 -2001)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Indigenous_women_are",
    "data-name": "Indigenous women are",
    transform: "translate(1182.5 2025)",
    fill: "#1d1d1d",
    fontSize: 20,
    fontFamily: "Oswald-Medium, Oswald",
    fontWeight: 500,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -91.61,
    y: 0
  }, "INDIGENOUS WOMEN ARE")), /*#__PURE__*/React.createElement("text", {
    id: "_12x",
    "data-name": "12x",
    transform: "translate(1185.5 2122)",
    fill: "#255e1c",
    fontSize: 100,
    fontFamily: "Oswald-Bold, Oswald",
    fontWeight: 700,
    letterSpacing: "-0.014em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -62.5,
    y: 0
  }, "12"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Oswald-ExtraLight, Oswald",
    fontWeight: 200
  }, "x")), /*#__PURE__*/React.createElement("text", {
    id: "more_likely_to_be_murdered_or_reported_missing",
    "data-name": "more likely to be murdered or reported missing",
    transform: "translate(1185.5 2143.5)",
    fill: "#1d1d1d",
    fontSize: 16,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -94.004,
    y: 0
  }, "more likely to be murdered"), /*#__PURE__*/React.createElement("tspan", {
    x: -67.804,
    y: 20
  }, "or reported missing")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4);
export default __webpack_public_path__ + "static/media/p4.ff991e64b632092a432c9dfd0a812221.svg";
export { ForwardRef as ReactComponent };